var icon = require('vue-svgicon')
icon.register({
  'ks-icon-usd': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M66.23 58.87c-10.59-2.75-14-5.6-14-10 0-5.09 4.71-8.63 12.6-8.63 8.31 0 11.39 4 11.67 9.8h10.31c-.33-8-5.23-15.4-15-17.78V22h-14v10.08C48.78 34 41.5 39.92 41.5 48.93c0 10.78 8.91 16.15 21.93 19.27 11.67 2.8 14 6.91 14 11.25 0 3.22-2.29 8.35-12.6 8.35-9.61 0-13.39-4.29-14-9.8H40.66c.56 10.22 8.21 16 17.17 17.87V106h14V96c9.1-1.63 16.33-7 16.33-16.57 0-13.28-11.34-17.76-21.93-20.56z"/>'
  }
})
